import { Box, Typography, Chip, useTheme, alpha } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LockIcon from "@mui/icons-material/Lock";
import PublicIcon from "@mui/icons-material/Public";
import dayjs from "dayjs";
import React from "react";

function GroupHeader({ group }) {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 3 }}>
      {/* Title row */}
      <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 2, mb: 1.5 }}>
        <Typography
          sx={{
            fontSize: { xs: "1.6rem", sm: "2rem" },
            fontWeight: 800,
            color: "text.primary",
            letterSpacing: "-0.02em",
            lineHeight: 1.15,
          }}
        >
          {group.title}
        </Typography>
        <Chip
          size="small"
          icon={group.isPrivate ? <LockIcon fontSize="small" /> : <PublicIcon fontSize="small" />}
          label={group.isPrivate ? "Private" : "Public"}
          sx={{
            mt: 0.5,
            flexShrink: 0,
            fontWeight: 600,
            fontSize: "0.72rem",
            bgcolor: group.isPrivate
              ? alpha(theme.palette.warning.main, 0.1)
              : alpha(theme.palette.success.main, 0.1),
            color: group.isPrivate ? "warning.dark" : "success.dark",
            border: `1px solid ${group.isPrivate
              ? alpha(theme.palette.warning.main, 0.25)
              : alpha(theme.palette.success.main, 0.25)}`,
            "& .MuiChip-icon": {
              color: group.isPrivate ? "warning.dark" : "success.dark",
              fontSize: "0.8rem",
            },
          }}
        />
      </Box>

      {/* Description */}
      {group.description && (
        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            lineHeight: 1.6,
            fontSize: "0.95rem",
            mb: 2,
            maxWidth: 600,
          }}
        >
          {group.description}
        </Typography>
      )}

      {/* Start date badge */}
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 1,
          px: 1.5,
          py: 0.75,
          borderRadius: 2,
          bgcolor: alpha(theme.palette.primary.main, 0.06),
          border: `1px solid ${alpha(theme.palette.primary.main, 0.15)}`,
        }}
      >
        <CalendarTodayIcon sx={{ fontSize: "0.85rem", color: "primary.main" }} />
        <Typography sx={{ fontSize: "0.78rem", fontWeight: 600, color: "text.secondary", textTransform: "uppercase", letterSpacing: "0.08em" }}>
          Start Date
        </Typography>
        <Typography sx={{ fontSize: "0.9rem", fontWeight: 700, color: "text.primary" }}>
          {dayjs(group.nextPayout).format("MMM D, YYYY")}
        </Typography>
      </Box>
    </Box>
  );
}

export default GroupHeader;
